import { create } from 'zustand';
import { persist, createJSONStorage, subscribeWithSelector } from 'zustand/middleware';

type OnboardingStore = {
  activeStep: number;
  previousStep: number | null;
  onboardingActive: boolean;
  reminderActive: boolean;
  isPartnerhubSession: boolean;
  setOnboardingActive: (flag: boolean) => void;
  addStep: (step: number) => void;
  setActiveStep: (step: number) => void;
  setReminderActive: (flag: boolean) => void;
  setIsPartnerhubSession: (flag: boolean) => void;
};

export const useOnboardingStore = create<OnboardingStore>()(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        activeStep: 1,
        previousStep: 0,
        onboardingActive: false,
        reminderActive: false,
        isPartnerhubSession: false,
        addStep: (step) => set({ activeStep: step, previousStep: get().activeStep as any }),
        setOnboardingActive: (flag) => set({ onboardingActive: flag }),
        setActiveStep: (step) => set({ activeStep: step }),
        setReminderActive: (flag) => set({ reminderActive: flag }),
        setIsPartnerhubSession: (flag) => set({ isPartnerhubSession: flag }),
      }),
      {
        name: 'onboarding-storage',
        storage: createJSONStorage(() => sessionStorage),
      }
    )
  )
);
